import { usePlateEditorState } from '@udecode/plate';
import PropTypes from 'prop-types';
import React from 'react';

import EndAndClose from './end_and_close';
import isEditorEmpty from 'components/text_editor_new/lib/is_editor_empty';
import SendButton from 'components/customer/composition/send_button';

export default function ChatActions({ disableSubmit, editorId, hasAttachments, onSubmit }) {
  const editor = usePlateEditorState(editorId);

  if (isEditorEmpty(editor) && !hasAttachments) {
    return <EndAndClose isEditorEmpty />;
  }

  return (
    <SendButton disabled={disableSubmit} onClick={onSubmit}>
      Send
    </SendButton>
  );
}

ChatActions.propTypes = {
  disableSubmit: PropTypes.bool,
  editorId: PropTypes.string,
  hasAttachments: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};
